/**
 * 客户详情 - 用旧的新改
 * 旧的index.jsx弃用
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React,{Component} from 'react'
import {Card,Row, Col,message,Spin,Button,Space,Affix,Tooltip} from 'antd'
import Lang from "@components/Lang/Lang"
import qs from 'query-string';
import dayjs from 'dayjs'
import {list,join} from "../../../api/customerDetail" ;
import {isEmpty} from '@utils/utils';
import { Link } from "react-router-dom";
import AuthBtn from "@components/HoverIcon/AuthBtn";
import './Detail.less'
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import FollowRecord from "../Follow/components/FollowRecord"
import SurveyTaskFromShow from "@components/SurveyTaskFromDrawer/SurveyTaskFromShow";
import CustomerEmailStatus from "@components/customerEmailStatus/customerEmailStatus";
import Locale from "@utils/locale";
let locale = Locale.current();
class CustomerDetail extends Component {
    state = {
        loading:false,
        models:{}
    }

    joinEssaOne(){
        let {models,loading} = this.state
        this.setState({
            loading:true
        },() => {
            join({id:models.buyerId})
            .then( (response)=> {
                if(response.data&&response.data.success&&response.data.valid){
                    message.info(
                        Lang({
                            id: "CaoZuoChengGong",
                            default: "操作成功",
                        })
                    );
                    window.location.reload()
                }else{
                    message.info(response.data.message)
                }
                this.setState({loading:false})
            })
            .catch((error)=>{
                message.error(error.message);
                this.setState({loading:false})
            })
        })

    }

    fetchData(id,callback){
        this.setState({
            loading:true
        },()=>{
            list({id})
                .then( (response)=> {
                    if(response.data&&response.data.success&&response.data.valid){
                        let models = response.data.model
                        if(callback){
                            callback(models)
                        }
                        if(!isEmpty(models.mainCategory)){
                            models["mainCategoryStr"] = models.mainCategory.split("|").filter((val)=>val!=="其他").join("，")+"，"
                        }
                        this.setState({
                            models: models,
                        })
                    }else{
                        message.info(response.data.message)
                    }
                    this.setState({loading:false})
                })
                .catch((error)=>{
                    message.error(error.message);
                    this.setState({loading:false})
                })
        })
    }
    componentWillMount(){
        const {id} = qs.parse(this.props.location.search)
        this.fetchData(id,res=>{
            document.title = res.code+" "+Lang({id:'ZhangHaoXiangQing',default:"客户详情"})
        })

    }

    componentDidMount(){
    }

    render() {
        const { loading , models} = this.state
        const crumb = [
            {name:  Lang({id: "KeHuLieBiao",default: "客户信息"}),link:"/customer/list"},
            {name: Lang({id:'ZhangHaoXiangQing',default:"客户详情"})}
            ];
        const md = 6;
        let label = 4;
        let content = 8;
        if(locale=='zh'){
            label = 3;
            content = 9;
        }
        if(locale=='en'){
            label = 5;
            content = 7;
        }
        return (
            <div>
                <CommonBreadcrumb list={crumb}></CommonBreadcrumb>
                <div className="customerDetail">
                    <Spin spinning={loading}>
                        <Card>
                                <div className="title">
                                    <Lang id="KeHuXinXi">客户信息</Lang>
                                </div>
                            <div className={'topInfo'}>
                                <Row gutter={[0,0]}>
                                    <Col span={6}>
                                        <div className={"h3Div"}>{models.code}</div>
                                    </Col>
                                    <Col span={18}>
                                        <Affix offsetTop={120}>
                                            <div className={"text-right"}>
                                                {
                                                models.isApplyEssaonePlatform != 1 ?<Button type="primary" onClick={(e) => this.joinEssaOne()}>
                                                    <Lang id="KaiTongESSAONE">开通 ESSAONE</Lang>
                                                </Button>:null
                                                }
                                                <Button type="primary" className='ml_8'>
                                                    <Link
                                                        className="link"
                                                        to={`/customer/scoreList?id=${models.buyerId}`}
                                                    >{Lang({id:"JiFenGuanLi",default:"积分管理"})}</Link>
                                                </Button>
                                                <Button type="primary" className='ml_8'>
                                                    <Link
                                                        className="link"
                                                        to={`/customer/couponList?id=${models.buyerId}`}
                                                    >{Lang({id:"KeHuYouHuiQuan",default:"客户优惠券"})}</Link>
                                                </Button>
                                                <Button type="primary" className='ml_8'>
                                                    <Link
                                                        className="link"
                                                        to={`/dataStatistics/cart?id=${models.buyerId}`}
                                                    ><Lang id="KeHuGouWuChe">客户购物车</Lang></Link>
                                                </Button>
                                                <Button className="ml_8" type="primary">
                                                    <Link
                                                        className="link"
                                                        to={`/dataStatistics/po?id=${models.buyerId}`}
                                                    ><Lang id="KeHuDingDan">客户订单</Lang></Link>
                                                </Button>
                                                <Button className="ml_8" type="primary">
                                                    <Link
                                                        className="link"
                                                        to={`/customer/fuzzy-list?id=${models.buyerId}`}
                                                    ><Lang id="ZhaoYang">找样</Lang></Link>
                                                </Button>
                                                {/* 跟进记录*/}
                                                <FollowRecord buyerId={models.buyerId}>
                                                    <Tooltip placement="top" title={<Lang id="GenJinJiLu">跟进记录</Lang>}>
                                                    <Button className="ml_8" type="primary">
                                                        <i className="ri-todo-line" />
                                                    </Button>
                                                    </Tooltip>
                                                </FollowRecord>
                                                {/* 满意度调查*/}
                                                <SurveyTaskFromShow buyerId={models.buyerId} item={{...models,buyerCode:models.code}} >
                                                    <Tooltip placement="top" title={<Lang id="ManYiDuDiaoCha">满意度调查</Lang>}>
                                                        <Button className="ml_8" type="primary">
                                                            <i className="ri-draft-line" />
                                                        </Button>
                                                    </Tooltip>
                                                </SurveyTaskFromShow>
                                            </div>
                                        </Affix>
                                    </Col>
                                </Row>
                                <Row>
                                    <Space size={'large'}>
                                        <Space><span className="ri-home-office-fill black66"></span>{models.name}</Space>
                                        <Space>
                                            {/*<span className="ri-mail-fill black66"></span>*/} 
                                            <div className={"flex-item-ver-center"}>
                                                <CustomerEmailStatus verifyEmailStatus={models.verifyEmailStatus+""} size={14} />
                                                <span className={"ml_8"}>{models.email}</span>
                                            </div>
                                            </Space>
                                        <Space><span className="ri-phone-fill black66"></span>{models.mobile}</Space>
                                        {/*isTargetCustomer  0:非目标  1:目标  2:暂无法确认*/}
                                        <Space>
                                            {models.isTargetCustomer==0&&<span className="spanTagWran"><Lang id="FeiMuBiaoYongHu">非目标用户</Lang></span>}
                                            {models.isTargetCustomer==1&&<span className="spanTag"><Lang id="MuBiaoYongHu">目标客户</Lang></span>}
                                            {models.isTargetCustomer==2&&<span className="spanTagWran"><Lang id="ZanWuFaQueRen">暂无法确认</Lang></span>}
                                        </Space>
                                    </Space>
                                </Row>
                            </div>
                            <Row>
                                <Col span={label} md={md} xxl={label}><Lang id="ShuiWHao">纳税人识别号</Lang></Col>
                                <Col span={content} md={md} xxl={content}>{models.taxRegistrationNo}</Col>
                                <Col span={label} md={md} xxl={label}><Lang id="YingYeZhiZhao">营业执照</Lang></Col>
                                <Col span={content} md={md} xxl={content}>{models.businessLicenseNo}</Col>
                            </Row>
                            <Row>
                                <Col span={label} md={md} xxl={label}><Lang id="JiaoHuoDiQu">交货地区</Lang></Col>
                                <Col span={content} md={md} xxl={content}>{models.lclDeliveryAddress}</Col>
                                <Col span={label} md={md} xxl={label}><Lang id="XiaoShouQuDao">销售渠道</Lang></Col>
                                <Col span={content} md={md} xxl={content}>{models.buySellChannel}</Col>
                            </Row>
                            <Row>
                                <Col span={label} md={md} xxl={label}><Lang id="GongSiDiZhi">公司地址</Lang></Col>
                                <Col span={content} md={md} xxl={content}>
                                    {models.country}&nbsp;&nbsp;{models.city}<br />
                                    {models.address}
                                </Col>
                            </Row>
                            <Row>
                                <Col span={label} md={md} xxl={label}><Lang id="YiXiangCaiGouShangPin">意向采购商品</Lang></Col>
                                <Col span={content} md={md} xxl={content}>{models.mainCategoryName}</Col>
                            </Row>
                            <Row className="border">
                                {
                                    models.type==='1'||models.type==='0'?
                                        <>
                                            <Col span={label} md={md} xxl={label}><Lang id="FenXiaoShang">分销商</Lang></Col>
                                            <Col span={content} md={md} xxl={content}>{models.channelMode}</Col>
                                            <Col span={label} md={md} xxl={label}><Lang id="FenXiaoShangLeiXing">分销商类型</Lang></Col>
                                            <Col span={content} md={md} xxl={content}>{models.typeName}</Col>
                                        </>:
                                        <>
                                            <Col span={label} md={md} xxl={label}><Lang id="TuiGuangFangShi">推广方式</Lang></Col>
                                            <Col span={content} md={md} xxl={content}>{models.promoteModeName}</Col>
                                            <Col span={label} md={md} xxl={label}><Lang id="QuDao">渠道</Lang></Col>
                                            <Col span={content} md={md} xxl={content}>{models.promoteChannelName}</Col>
                                        </>
                                }
                            </Row>

                        </Card>
                        <Card style={{marginTop:16}}>
                            <div className="title title-flex">
                                <Lang id="KeHuShuJu">客户行为数据</Lang>
                                </div>
                            <Row>
                                <Col span={label} md={md} xxl={label}><Lang id="DengLuTianShu">登录天数</Lang></Col>
                                <Col span={content} md={md} xxl={content}>{models.loginNum}</Col>
                                <Col span={label} md={md} xxl={label}><Lang id="ZuiJinJiaGouShiJian">最近加购时间</Lang></Col>
                                <Col span={content} md={md} xxl={content}>{models.lastAddCartTime?dayjs(models.lastAddCartTime).format('YYYY-MM-DD'):null}</Col>
                            </Row>
                            <Row>
                                <Col span={label} md={md} xxl={label}><Lang id="JiaGouKuanShu">加购款数</Lang></Col>
                                <Col span={content} md={md} xxl={content}>{models.addCartSkuNum||0}</Col>
                                <Col span={label} md={md} xxl={label}><Lang id="ZuiJinFangWenShiJian">最近访问时间</Lang></Col>
                                <Col span={content} md={md} xxl={content}>{models.lastVisitTime?dayjs(models.lastVisitTime).format('YYYY-MM-DD'):null}</Col>
                            </Row>
                            <Row>
                                <Col span={label} md={md} xxl={label}><Lang id="LeiJiDingDanShu">累计订单数</Lang></Col>
                                <Col span={content} md={md} xxl={content}>{models.orderTotalNum||0}</Col>
                                <Col span={label} md={md} xxl={label}><Lang id="ZuiJinXiaDanShiJian">最近下单时间</Lang></Col>
                                <Col span={content} md={md} xxl={content}>{models.lastOrderTime?dayjs(models.lastOrderTime).format('YYYY-MM-DD'):null}</Col>
                            </Row>
                        </Card>
                        <Card style={{marginTop:16}}>
                            <div className="title"><Lang id="KeHuGenJinXinXi">客户跟进信息</Lang></div>
                            <Row>
                                <Col span={label} md={md} xxl={label}><Lang id="LianXiRen">联系人</Lang></Col>
                                <Col span={content} md={md} xxl={content}>{models.contact}</Col>
                                <Col span={label} md={md} xxl={label}><Lang id="LianXiRenZhiWu">联系人职务</Lang></Col>
                                <Col span={content} md={md} xxl={content}>{models.position}</Col>
                            </Row>
                            <Row>
                                <Col span={label} md={md} xxl={label}><Lang id="GongSiLeiXing">公司类型</Lang></Col>
                                <Col span={content} md={md} xxl={content}>{models.companyType}</Col>
                                <Col span={label} md={md} xxl={label}><Lang id="XiaoShouQuDao">销售渠道</Lang></Col>
                                <Col span={content} md={md} xxl={content}>{models.sellChannel}</Col>
                            </Row>
                            <Row>
                                <Col span={label} md={md} xxl={label}><Lang id="JingYingLeiMu">经营类目</Lang></Col>
                                <Col span={content} md={md} xxl={content}>
                                    {models.mainCategoryStr}
                                    {/*{Helper.isString(models.mainCategory) && models.mainCategory.split(",").filter((val)=>val!=="其他").join(",")+","}{models.manageCategory && <br/>}{models.otherCategory}*/}
                                    </Col>
                                <Col span={label} md={md} xxl={label}><Lang id="NianXiaoShouE">年销售额</Lang></Col>
                                <Col span={content} md={md} xxl={content}><span>{models.annualSale}</span></Col>
                            </Row>
                            <Row>
                                <Col span={label} md={md} xxl={label}><Lang id="XianXiaMenDianShuLiang">线下门店数量</Lang></Col>
                                <Col span={content} md={md} xxl={content}>{models.storeNum}</Col>
                                <Col span={label} md={md} xxl={label}><Lang id="ZaiShouSKUShu">在售SKU数</Lang></Col>
                                <Col span={content} md={md} xxl={content}>{models.salesSkuCount}</Col>
                            </Row>
                            <Row>
                                <Col span={label} md={md} xxl={label}><Lang id="GongSiWangZhi">公司网址</Lang></Col>
                                <Col span={content} md={md} xxl={content}>{models.url}</Col>
                            </Row>
                            <Row>
                                <Col span={label} md={md} xxl={label}><Lang id="BeiZhu">备注</Lang></Col>
                                <Col span={content} md={md} xxl={content}>{models.remark}</Col>
                            </Row>

                            <Row className="border">
                                <Col span={label} md={md} xxl={label}><Lang id="GenJinRenYuan">跟进人员</Lang></Col>
                                <Col span={content} md={md} xxl={content}>{models.followerUser}</Col>
                            </Row>
                            <Row>
                                <Col span={label} md={md} xxl={label}><Lang id="ShouCiGenJin">首次跟进</Lang></Col>
                                <Col span={content} md={md} xxl={content}>
                                    {models.firstFollowerUser}
                                    {
                                        models.createTime&&<span>&nbsp;&nbsp;|&nbsp;&nbsp;{dayjs(models.createTime).format('YYYY-MM-DD HH:mm:ss')}</span>
                                    }
                                </Col>
                            </Row>
                        </Card>
                    </Spin>
                </div>
            </div>
        )
    }
}

export default CustomerDetail;
